/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */

// https://docs.google.com/spreadsheets/d/15ZCFOAqMljpN9AhnzXLwVmWZNzEfr6_1IUWP0HP63xc/edit#gid=0

// ----------PIO
// Equilab format
// QQ+, 88-77, 66, 87s, 72s+, 64s+, AJo+, A5o-A2o, 85o-84o
// where 72s+ = 72s, 73s, 74s, 75s, 76s
// where 64s+ = 64s, 65s
// where QQ+ = QQ, KK, AA
// where A5o-A2o = A5o, A4o, A3o, A2o

// Flopzilla format (full range all combos)
// AA-22,AKo-A2o,KQo-K2o,QJo-Q2o,JTo-J2o

// PIO format
// 2d2c: 0.1,2h2c: 0.1,2h2d: 0.1,2s2c: 0.1,2s2d: 0.1,2s2h: 0.8
// 22:1, AA

// ----------GTO+
// SimplePoker format
// [2.17]AsJh[/2.17], [2.18]AsJd[/2.18], [4.32]KcKd[/4.32], [4.33]KcKh[/4.33], [5.15]JsTs[/5.15]

// GTO+ format
// AA-KK,[75.0]QQ,AKs,AKo-AQo[/75.0],[27.6]94s,84s[/27.6],[18.2]T5o[/18.2],[11.5]K6o-K5o,Q6o-Q5o[/11.5],[6.40]66[/6.40]
// [2.99]Jd9h[/2.99], [50.0]Ad5h, As5h, Ac5h[/50.0], Ah2h, Ad2d
// 55, A2s, [2.99]Jd9h[/2.99], [50.0]Ad5h, As5h, Ac5h[/50.0]

// [20.7%]KJs[/20.7%],A2s,A5o,A6s,A7s,A8s,74s,75s,77,85s,86s,95s,96s,97s,98o,T6s,T7s,T9o,J7s,J8s,J9s,JTs,JTo,Q2s,Q3s,Q4s,Q5s,Q6s,Q7s,Q8s,Q9s,QTo,QJs,QJo,K2s,K3s,K4s,K5s,K8s,K9s,KTo,KJo,KQo,[17.6%]A2o[/17.6%],[93.6%]A3s[/93.6%],A8o,A9s,A9o,ATo,AJo,22,32s,33,42s,43s,44,52s,53s,55,63s,64s,[24.2%]A3o[/24.2%],[75.2%]A4s[/75.2%],[67.2%]A4o[/67.2%],[77.4%]A6o[/77.4%],[76.9%]A7o[/76.9%],[70.4%]ATs[/70.4%],[54.4%]54s[/54.4%],[25.4%]54o[/25.4%],[64.5%]65s[/64.5%],[1.2%]65o[/1.2%],[75.7%]66[/75.7%],[44%]76s[/44%],[67.8%]76o[/67.8%],[51%]87s[/51%],[85%]87o[/85%],[86.3%]88[/86.3%],[43.1%]98s[/43.1%],[81.3%]99[/81.3%],[36.6%]T3s[/36.6%],[39.2%]T4s[/39.2%],[47.3%]T5s[/47.3%],[96.2%]T8s[/96.2%],[59.1%]T8o[/59.1%],[64.6%]T9s[/64.6%],[51.7%]J3s[/51.7%],[60.5%]J4s[/60.5%],[75.3%]J5s[/75.3%],[69.5%]J6s[/69.5%],[40.2%]J8o[/40.2%],[52%]J9o[/52%],[34.2%]Q8o[/34.2%],[59.9%]Q9o[/59.9%],[83.2%]QTs[/83.2%],[83.7%]K6s[/83.7%],[34.6%]K6o[/34.6%],[89.2%]K7s[/89.2%],[27.2%]K7o[/27.2%],[73.3%]K8o[/73.3%],[80.4%]K9o[/80.4%],[80.7%]KTs[/80.7%],
// A2s,A5o,[20.7%]KJs[/20.7%],A6s,A7s,A8s,74s,75s,77,85s,86s,95s,96s,97s,98o,T6s,T7s,T9o,J7s,J8s,J9s,JTs,JTo,Q2s,Q3s,Q4s,Q5s,Q6s,Q7s,Q8s,Q9s,QTo,QJs,QJo,K2s,K3s,K4s,K5s,K8s,K9s,KTo,KJo,KQo,[17.6%]A2o[/17.6%],[93.6%]A3s[/93.6%],A8o,A9s,A9o,ATo,AJo,22,32s,33,42s,43s,44,52s,53s,55,63s,64s,[24.2%]A3o[/24.2%],[75.2%]A4s[/75.2%],[67.2%]A4o[/67.2%],[77.4%]A6o[/77.4%],[76.9%]A7o[/76.9%],[70.4%]ATs[/70.4%],[54.4%]54s[/54.4%],[25.4%]54o[/25.4%],[64.5%]65s[/64.5%],[1.2%]65o[/1.2%],[75.7%]66[/75.7%],[44%]76s[/44%],[67.8%]76o[/67.8%],[51%]87s[/51%],[85%]87o[/85%],[86.3%]88[/86.3%],[43.1%]98s[/43.1%],[81.3%]99[/81.3%],[36.6%]T3s[/36.6%],[39.2%]T4s[/39.2%],[47.3%]T5s[/47.3%],[96.2%]T8s[/96.2%],[59.1%]T8o[/59.1%],[64.6%]T9s[/64.6%],[51.7%]J3s[/51.7%],[60.5%]J4s[/60.5%],[75.3%]J5s[/75.3%],[69.5%]J6s[/69.5%],[40.2%]J8o[/40.2%],[52%]J9o[/52%],[34.2%]Q8o[/34.2%],[59.9%]Q9o[/59.9%],[83.2%]QTs[/83.2%],[83.7%]K6s[/83.7%],[34.6%]K6o[/34.6%],[89.2%]K7s[/89.2%],[27.2%]K7o[/27.2%],[73.3%]K8o[/73.3%],[80.4%]K9o[/80.4%],[80.7%]KTs[/80.7%],

import { rangesDataSkeleton } from '@/helpers/solution'

const rankStrings = ['2', '3', '4', '5', '6', '7', '8', '9', 'T', 'J', 'Q', 'K', 'A']
const suitStrings = ['c', 'd', 'h', 's']

function getHand(combo, weight) {
  return {
    combo,
    weight,
  }
}

function setWeightCanonicalCombo(comboStr, weight, range) {
  const rank0 = rankStrings.indexOf(comboStr[0])
  const suit0 = suitStrings.indexOf(comboStr[1])
  const rank1 = rankStrings.indexOf(comboStr[2])
  const suit1 = suitStrings.indexOf(comboStr[3])
  if (rank0 < 0 || rank1 < 0 || suit0 < 0 || suit1 < 0) return

  const highRank = rank0 > rank1 ? comboStr[0] : comboStr[2]
  const lowRank = rank0 < rank1 ? comboStr[0] : comboStr[2]

  let hand169 = highRank + lowRank
  if (comboStr[1] === comboStr[3]) {
    // Suited
    hand169 += 's'
  } else if (comboStr[0] !== comboStr[2]) {
    // Offsuit
    hand169 += 'o'
  }
  // console.log(hand169)
  // if (hand169 === 'AA') {
  // debugger
  // }
  range[hand169] = getHand(hand169, weight)
}

function setWeightComboWithHyphen(comboStr, weight, range) {
  const hyphenIdx = comboStr.indexOf('-')
  const topHand = comboStr.substring(0, hyphenIdx)
  const lowHand = comboStr.substring(hyphenIdx + 1)

  if (topHand.length !== lowHand.length && topHand.length !== 2 && topHand.length !== 3) return

  if (topHand.length === 2) {
    // Doing all pairs between the two (e.g. AA-22)
    if (topHand[0] !== topHand[1] || lowHand[0] !== lowHand[1]) return

    const topRank = rankStrings.indexOf(topHand[0])
    const lowRank = rankStrings.indexOf(lowHand[0])

    if (lowRank < 0 || topRank < 0) return

    for (let i = lowRank; i <= topRank; i++) {
      const newHand = rankStrings[i] + rankStrings[i]
      range[newHand] = getHand(newHand, weight)
    }
  } else if (topHand.length === 3) {
    // Suited or offsuit combo (e.g. AKo-A2o, A8s-A5s, T8s-T5s)
    if (topHand[0] !== lowHand[0] || topHand[2] !== lowHand[2]) return

    const highRank = rankStrings.indexOf(topHand[0])
    const topLowRank = rankStrings.indexOf(topHand[1])
    const lowLowRank = rankStrings.indexOf(lowHand[1])

    if (highRank < 0 || topLowRank < 0 || lowLowRank < 0) return

    for (let i = lowLowRank; i <= topLowRank; i++) {
      const newHand = topHand[0] + rankStrings[i] + topHand[2]
      range[newHand] = getHand(newHand, weight)
    }
  } else {
    // Invalid string
  }
}

function setWeightComboWithPlus(rawcomboStr, weight, range) {
  const plusIdx = rawcomboStr.indexOf('+')
  const hand = rawcomboStr.substring(0, plusIdx)

  if (hand.length === 2) {
    // Doing all pairs starting from combo
    if (hand[0] !== hand[1]) return

    const rank = rankStrings.indexOf(hand[0])

    if (rank < 0) return

    for (let i = rank; i < rankStrings.length; i++) {
      const newHand = rankStrings[i] + rankStrings[i]
      range[newHand] = getHand(newHand, weight)
    }
  } else if (hand.length === 3) {
    // Suited or offsuit combo (e.g. A8o+, 75s+)
    const highRank = rankStrings.indexOf(hand[0])
    const lowRank = rankStrings.indexOf(hand[1])

    if (highRank < 0 || lowRank < 0) return

    for (let i = lowRank; i < highRank; i++) {
      const newHand = hand[0] + rankStrings[i] + hand[2]
      range[newHand] = getHand(newHand, weight)
    }
  } else {
    // Invalid string
  }
}

function isOffsuitAndSuited(comboStr) {
  return comboStr.length === 2 && comboStr[0] !== comboStr[1]
}

function setWeightCombo(comboStr, weight, range) {
  // Set to increments of 0.01 since that's what our UI expects
  weight = Math.round(weight * 100) / 100
  weight = Math.max(Math.min(weight, 1.0), 0)

  if (weight <= 0) return

  try {
    if (comboStr.includes('-')) {
      setWeightComboWithHyphen(comboStr, weight, range)
    } else if (comboStr.includes('+')) {
      setWeightComboWithPlus(comboStr, weight, range)
    } else if (comboStr.length === 4) {
      setWeightCanonicalCombo(comboStr, weight, range)
    } else if (isOffsuitAndSuited(comboStr)) {
      // User provided a string like "AJ", including both offsuit and suited combos
      range[`${comboStr}s`] = getHand(`${comboStr}s`, weight)
      range[`${comboStr}o`] = getHand(`${comboStr}o`, weight)
    } else {
      range[comboStr] = getHand(comboStr, weight)
    }
  } catch (err) {
    console.log(err)
  }
}

function importPioRange(inputRange) {
  const range = {}
  const hands = inputRange.split(',')
  hands.forEach(hand => {
    const [comboStr, weightStr] = hand.split(':').map(str => str.trim())
    const weight = weightStr ? parseFloat(weightStr) : 1
    if (isNaN(weight)) return
    // range[comboStr] = weight
    if (!range.hasOwnProperty(comboStr)) {
      setWeightCombo(comboStr, weight, range)
    }
  })
  // console.log(range)
  // debugger
  return range
}

// OLD - keep for reference if I just messed it up (delete later - 08.12 2023)
// function importGtoPlusRange(inputRange) {
//   let range = {}
//   // Transform input like
//   // "[75.0]KK-QQ,AKs,AKo-AQo[/75.0],[28.5]94s,84s[/28.5]"
//   // to ["75.0", "KK-QQ,AKs,AKo-AQo", "28.5", "94s,84s"]
//   let categories = inputRange.split(/[[\]]/)
//   categories = categories.map(cc => cc.split(','))
//   categories = categories.flat()

//   // categories = categories.filter(str => str && !str.includes('/') && !str.includes(','))
//   // GTO+ sometimes store the weights with a '%' for some obscure reason..
//   categories = categories.map(e => e.replaceAll('%', '').replaceAll(' ', '').replaceAll('\n', ''))
//   categories = categories.filter(str => str && !str.includes(','))

//   if (inputRange.length < 2 || categories.length < 1) {
//     return range
//   }

//   let weight = 1.0
//   let lastWeighIdx = -1
//   if (inputRange[0] === '[') {
//     // The list starts with a weight
//     lastWeighIdx = 0
//     weight = parseFloat(categories[0])
//     if (isNaN(weight)) {
//       return range
//     }
//     // NB: GTO+ stores weight in percentages
//     weight /= 100.0
//   }
//   // console.log(categories)
//   for (let i = 0; i < categories.length; i++) {
//     let catItem = categories[i]
//     // console.log(catItem)
//     if (catItem.includes('/')) {
//       // reset weight when we encounter a '/' cos next item can be without weight like just AA-22
//       // console.log('RESETING weight to', weight, catItem)
//       weight = 1.0
//     } else if (i > lastWeighIdx + 1 && !isNaN(Number(catItem))) {
//       // 84s parseFloat() gets ya num 84 !
//       // } else if (i > lastWeighIdx + 1 && !isNaN(parseFloat(catItem))) {

//       // Changing weight: NB: GTO+ stores weight in percentages
//       // console.log('CHANGING weight to', weight)
//       weight = Number(catItem) / 100
//       lastWeighIdx = i
//     } else {
//       const hands = catItem.split(',')
//       for (const hand of hands) {
//         if (!range.hasOwnProperty(hand)) {
//           // console.log(hand, weight, range)
//           // debugger
//           setWeightCombo(hand, weight, range)
//         }
//       }
//     }
//   }
//   return range
// }

function importGtoPlusRange(inputRange) {
  const range = {}

  let list = inputRange
    .replaceAll('[/', 'weightEnd_')
    .replaceAll('[', 'weightStart_')
    .replaceAll('%', '')
    .replaceAll(' ', '')
    .replaceAll('\n', '')
  list = list.split(']')

  list = list.map(cc =>
    cc.includes('weightEnd_') ? [cc.split('weightEnd_')[0], 'weightEnd_'] : cc,
  )

  list = list.flat().filter(i => i)
  list = list.map(cc => cc.split(','))
  list = list.flat().filter(i => i)

  if (inputRange.length < 2 || list.length < 1) {
    return range
  }

  let weight = 1.0
  let lastWeighIdx = -1

  const getWeightFromWeightStart = item => {
    const strWeight = item.replace('weightStart_', '')
    weight = parseFloat(strWeight)
    // NB: GTO+ stores weight in percentages
    weight /= 100.0
    return weight
  }

  // If list starts with a weight
  if (list[0].includes('weightStart_')) {
    weight = getWeightFromWeightStart(list[0])
    if (isNaN(weight)) {
      return range
    }
    lastWeighIdx = 0
  }

  for (let i = 0; i < list.length; i++) {
    const item = list[i]
    if (item.includes('weightEnd_')) {
      // reset weight when we encounter a 'weightEnd_' cos next item can be without weight like just AA-22
      weight = 1.0
    } else if (i > lastWeighIdx + 1 && item.includes('weightStart_')) {
      weight = getWeightFromWeightStart(item)
      if (isNaN(weight)) {
        return range
      }
      lastWeighIdx = i
    } else {
      const hands = item.split(',')
      for (const hand of hands) {
        if (!range.hasOwnProperty(hand)) {
          setWeightCombo(hand, weight, range)
        }
      }
    }
  }
  return range
}

function importRange(inputRange) {
  let groups = null
  let format = ''
  if (inputRange.includes('[') || inputRange.includes(']')) {
    format = 'GtoPlus'
    groups = importGtoPlusRange(inputRange)
  } else {
    format = 'PIO'
    groups = importPioRange(inputRange)
  }

  const { tableGroups: l_tableGroups } = rangesDataSkeleton()

  const tableGroups = l_tableGroups.map(gg => {
    const hands = gg.combos.map(cc => cc.id)
    const r = {
      id: gg.id,
      range: groups[gg.id]?.weight || 0,
      hands,
      hand_count: gg.hand_count,
    }
    return r
  })

  const res = {
    error: tableGroups.reduce((acc, gg) => acc + gg.range, 0) <= 0,
    tableGroups,
    groups,
    format,
  }
  return res
}

export {
  importPioRange, //
  importGtoPlusRange,
  importRange,
  // importGtoPlusRanges,
}
